import { useEffect, useState } from "react";
import { FileText, ExternalLink } from "lucide-react";
import api from "@/lib/api";
import { PageHero, Loading, Empty } from "@/components/common";

export default function Biblioteca() {
  const [items, setItems] = useState(null);
  const [cat, setCat] = useState("");

  useEffect(() => {
    setItems(null);
    api.get("/documents", { params: cat ? { category: cat } : {} }).then((r) => setItems(r.data)).catch(() => setItems([]));
  }, [cat]);

  const cats = items ? [...new Set(items.map((d) => d.category).filter(Boolean))] : [];

  return (
    <div data-testid="biblioteca-page">
      <PageHero label="Biblioteca" title="Documentos y fuentes primarias"
        subtitle="Evidencia centralizada: contratos, informes y fuentes originales que respaldan cada investigación." />
      <div className="max-w-6xl mx-auto px-6 py-10">
        {!cat && cats.length > 0 && (
          <div className="flex flex-wrap gap-2 mb-8">
            <button onClick={() => setCat("")} className="px-4 py-2 rounded-full text-sm bg-slate-900 text-white">Todos</button>
            {cats.map((c) => (
              <button key={c} onClick={() => setCat(c)} data-testid={`doc-cat-${c}`}
                className="px-4 py-2 rounded-full text-sm bg-white border border-slate-200 text-slate-600 hover:bg-slate-100">{c}</button>
            ))}
          </div>
        )}
        {cat && <button onClick={() => setCat("")} className="mb-6 text-sm text-cyan-600 font-semibold">← Todas las categorías</button>}
        {items === null ? <Loading /> : items.length === 0 ? <Empty label="No hay documentos disponibles." /> : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            {items.map((d) => (
              <div key={d.id} data-testid={`document-card-${d.id}`} className="bg-white rounded-lg border border-slate-200 p-5 hover:shadow-md transition-all">
                <div className="w-10 h-10 rounded-lg bg-slate-100 flex items-center justify-center mb-3">
                  <FileText className="w-5 h-5 text-slate-500" />
                </div>
                {d.category && <span className="text-xs font-semibold text-cyan-600 uppercase tracking-wide">{d.category}</span>}
                <h3 className="font-heading font-bold text-base text-slate-900 mt-1 mb-2">{d.title}</h3>
                {d.description && <p className="text-slate-600 text-sm line-clamp-2 mb-3">{d.description}</p>}
                {d.source_url && (
                  <a href={d.source_url} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 text-sm font-semibold text-cyan-600 hover:underline">
                    <ExternalLink className="w-3.5 h-3.5" /> Ver fuente
                  </a>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
